// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__299gS","error":"Home_error__4bpb1"};